import {  AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import { GlobalService } from 'src/app/_services/global.service';
import { environment } from 'src/environments/environment';
import { Location } from '@angular/common'

@Component({
  selector: 'app-java-redirect',
  templateUrl: './java-redirect.component.html',
  styleUrls: ['./java-redirect.component.css']
})
export class JavaRedirectComponent implements AfterViewInit {
  actionjava='';
  actionSegnalazioni='';
  @Input() actionLogin: any;
  @ViewChild('autologinform') loginform:ElementRef;
  @ViewChild('usrname') usrname:ElementRef;
  @ViewChild('pwd') pwd:ElementRef;

  constructor(  private activatedRoute:ActivatedRoute,
    private globalService:GlobalService,
    private cdRef: ChangeDetectorRef,  
    private router: Router,
    private location: Location
    ) { }

  ngOnInit(): void {
    if(!this.actionLogin){
    
      if(this.activatedRoute.snapshot.url.length>1){
        let cpath='';
    
        for(let j=1;j<this.activatedRoute.snapshot.url.length;j++){
          if(cpath!=''){
            cpath+='/';
          } 
      
          cpath+=this.activatedRoute.snapshot.url[j].path.replace('QUESTION','?').replace('UGUAL','=');
        }
    
        if(cpath.indexOf('http')>=0){      
          window.open(cpath.replace('http:/','http://').replace('https:/','https://'), '_blank');
          document.location.href="/";
        } else {
          if(cpath.indexOf('arkiweb2')>=0){     
            this.actionjava='https://'+cpath;    
          } else {
            this.actionjava=environment.JAVALOGINURL+cpath;    
          }
        }   
      }
    }
  }
  ngAfterViewInit() {

    if(!this.actionLogin){
      if((this.actionjava!='')&&(this.activatedRoute.snapshot.url.length>1)&&(this.activatedRoute.snapshot.url[0].path=='java')){
        let logInfo = JSON.parse(localStorage.getItem("logInfo"));
   
        this.pwd.nativeElement.value=logInfo.password;
        this.usrname.nativeElement.value=logInfo.username;
        this.loginform.nativeElement.setAttribute("target", "_blank");
        this.loginform.nativeElement.submit();
        this.location.back();
       
     //     this.router.navigate(['/dashboard/'])
     //     .then(() => {
      //  window.location.reload();
      //  });
      } 
    }else{
      setTimeout(() => {
       
        this.actionjava=environment.JAVALOGINURL+this.actionLogin;    
        let logInfo = JSON.parse(localStorage.getItem("logInfo"));
        this.pwd.nativeElement.value=logInfo.password;
        this.usrname.nativeElement.value=logInfo.username;
        this.cdRef.detectChanges(); 
        this.loginform.nativeElement.setAttribute("target", "formresponse");
        this.loginform.nativeElement.submit();
        
      });
     
    }
  }


  public submitForm(action, method, formGroup: any) {
    const form = document.createElement('form');
    form.style.display = 'none';
    form.method = method;
   // form.target = '_blank';
    form.action = environment.JAVALOGINURL+action;
    let input;
    for (const [key, value] of Object.entries(formGroup)) {
      input = document.createElement('input');
      input.name = key;
      input.id = key;
      input.value = value;
      form.appendChild(input);
    }
    document.body.appendChild(form);
      form.submit();
  }

}
